import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {IconSize} from '../Icon/Icon';
import {GenericIconName, useSharedIconUrl} from '../Icon/IconName';
import {MaskLayer} from '../MaskLayer/MaskLayer';

/**
 * The "SALE" tag icon in two colours: the tag SHAPE is filled with
 * `backgroundColor` (backend `background_color`) and the "%" glyph with
 * `foregroundColor` (backend `foreground_color`), rendered as a masked layer
 * on top of the tag. When `foregroundColor` is omitted the "%" is not shown.
 * See ASFE-14225.
 */
export const SaleTagIcon: FC<{
  className?: string;
  backgroundColor: string;
  foregroundColor?: string;
  size?: keyof typeof IconSize;
  'data-testid'?: string;
}> = ({
  className,
  backgroundColor,
  foregroundColor,
  size = 'XS',
  'data-testid': dataTestid,
}) => {
  const tagUrl = useSharedIconUrl(GenericIconName.SaleBG);
  const percentUrl = useSharedIconUrl(GenericIconName.SalePercent);
  const px = `${IconSize[size]}px`;

  return (
    <Container
      className={className}
      data-testid={dataTestid}
      style={{width: px, height: px}}
    >
      <MaskLayer $iconUrl={tagUrl} style={{background: backgroundColor}} />
      {foregroundColor ? (
        <MaskLayer
          $iconUrl={percentUrl}
          style={{background: foregroundColor}}
        />
      ) : null}
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  display: inline-block;
  flex-shrink: 0;
`;
